import { Customer, CustomerAction, CustomerActions, CustomersFilter, FetchSuccessCustomerPayload } from '../model/customer';
import { Process, ProcessAction, ProcessActions } from '../model';
import { ResponsePayload } from '../model/request';
import { findIndex, take, takeRight, uniqBy } from 'lodash';
import createReducer from './createReducer';

export const customers = createReducer<Customer[]>([], {
  [CustomerActions.FETCH_CUSTOMERS_SUCCESS](
    state: Customer[],
    action: CustomerAction
  ) {
    return (action.payload as ResponsePayload<FetchSuccessCustomerPayload>).data.items;
  },
  [CustomerActions.FETCH_CUSTOMERS](
    state: Customer[],
    action: CustomerAction
  ) {
    return null;
  },
  [CustomerActions.FETCH_MORE_CUSTOMERS_SUCCESS](
    state: Customer[],
    action: CustomerAction
  ) {
    return uniqBy([
      ...(state || []),
      ...(action.payload as ResponsePayload<FetchSuccessCustomerPayload>).data.items
    ], c => c.id);
  },
  [CustomerActions.FETCH_DETAILS_SUCCESS](
    state: Customer[],
    action: CustomerAction
  ) {
    const customer = (action.payload as ResponsePayload<Customer>).data;
    const index = findIndex(state, c => c.id === customer.id);

    return [
      ...take(state, index),
      customer,
      ...takeRight(state, state.length - (index + 1))
    ];
  },
});

export const customersFilter = createReducer<CustomersFilter | null>(null, {
  [CustomerActions.FETCH_FILTER_SUCCESS](
    state: CustomersFilter | null,
    action: CustomerAction
  ) {
    return (action.payload as ResponsePayload<CustomersFilter>).data;
  },
});

export const customersCount = createReducer<number>(0, {
  [CustomerActions.FETCH_CUSTOMERS_SUCCESS](state: number, action: CustomerAction) {
    return (action.payload as ResponsePayload<FetchSuccessCustomerPayload>).data.count;
  },
});

export const selectedCustomer = createReducer<Customer | null>(null, {
  [CustomerActions.SELECT_CUSTOMER](state: Customer, action: CustomerAction) {
    return action.payload as Customer;
  },
  [ProcessActions.EDIT_PROCESS](state: Customer, action: ProcessAction) {
    const process = action.payload as Process;
    return process.customer;
  },
  [ProcessActions.CLEAR_NEW_PROCESS](state: Customer, action: ProcessAction) {
    return null;
  },
  [CustomerActions.FETCH_DETAILS_SUCCESS](
    state: Customer,
    action: CustomerAction
  ) {
    const customer = (action.payload as ResponsePayload<Customer>).data;
    if (state?.id === customer.id) {
      return {
        ...state,
        ...customer,
      }
    }

    return state;
  },
});